import { createSlice } from '@reduxjs/toolkit';

/**
 * 파일 필드 설정 상태 관리
 * - previewFilePathField: 미리보기 파일 경로 필드명 (기본값: 'previewFilePath')
 * - previewFileName: 미리보기 파일명
 * - previewUrl: 미리보기 URL
 * - 사용 예시:
 *  dispatch(setFileFields({
 *    previewFilePathField: 'previewFilePath',
 *    previewFileName: '파일명',
 *    previewUrl: '파일URL'
 *  }));
 */

const initialState = {
  previewFilePathField: 'previewFilePath',
  previewFileName: '',
  previewUrl: '',
};

const FileFieldSlice = createSlice({
  name: 'FileField',
  initialState,
  reducers: {
    setFileFields: (state, action) => {
      const {
        previewFilePathField = 'previewFilePath',
        previewFileName = '',
        previewUrl = '',
      } = action.payload || {};
      if (previewFilePathField !== undefined)
        state.previewFilePathField = previewFilePathField;
      if (previewFileName !== undefined)
        state.previewFileName = previewFileName;
      if (previewUrl !== undefined) state.previewUrl = previewUrl;
    },
    resetFileFields: (state) => {
      state.previewFilePathField = 'previewFilePath';
      state.previewFileName = '';
      state.previewUrl = '';
    },
  },
});

export const { setFileFields, resetFileFields } = FileFieldSlice.actions;
export default FileFieldSlice.reducer;
